import React, { FC } from 'react'

import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { useGetCampaignGenresQuery } from 'src/Redux/spotifyCampaignGenresApi'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'

import { SpotifyGenresModalContent } from './SpotifyGenresModalContent'

const Container = styled.div<{ $withMargin?: boolean }>`
  display: flex;
  padding-top: ${(props) => (props.$withMargin ? '24px' : '72px')};
  padding-bottom: 80px;
  padding-left: 16px;
  padding-right: 16px;
  flex-direction: column;
  gap: 24px;
  position: relative;

  & > *:first-child + * {
    margin-top: ${(props) => (props.$withMargin ? '-24px' : '0')};
    margin-bottom: ${(props) => (props.$withMargin ? '-24px' : '0')};
  }

  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    margin: 0 auto;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 64px;
    width: 600px;
  }
`
const StyledSkeleton = styled(PrimarySkeleton)`
  height: 120px;
`

export const SpotifyGenresModal: FC = () => {
  const { setSearch } = useCustomSearchParams()
  const { number } = useParams<{ number: string }>()
  const { isLoading } = useGetCampaignGenresQuery(number || '', {
    skip: !number,
  })
  return (
    <FullScreenModal
      showCloseButton
      fixedCloseButton={false}
      open
      closable
      prefixCls='genres'
      onCancel={() => setSearch({ modal: null })}
    >
      {isLoading ? (
        <Container>
          <StyledSkeleton />
          <StyledSkeleton />
          <StyledSkeleton />
        </Container>
      ) : (
        <Container $withMargin>
          <SpotifyGenresModalContent />
        </Container>
      )}
    </FullScreenModal>
  )
}
